// src/utils/linkedinAuth.js
import { setAuthToken } from './authFetch';

const LINKEDIN_CLIENT_ID = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
const REDIRECT_URI = process.env.REACT_APP_LINKEDIN_REDIRECT_URI || `${window.location.origin}/linkedin-callback`;

const generateState = () =>
  Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

const getLinkedInAuthUrl = (state) => {
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: LINKEDIN_CLIENT_ID,
    redirect_uri: REDIRECT_URI,
    state,
    scope: 'openid profile email',
  });
  return `https://www.linkedin.com/oauth/v2/authorization?${params.toString()}`;
};

export const initiateLinkedInLogin = () => {
  const state = generateState();
  sessionStorage.setItem('linkedin_oauth_state', state);
  window.location.href = getLinkedInAuthUrl(state);
};

/**
 * Call this after /linkedin_auth returns a token.
 * Stores the backend-issued JWT so authFetch can use it.
 */
export const storeLinkedInToken = (token) => {
  if (token) setAuthToken(token);
};